const configEnv = [
  {
    url: "localhost",
    tenantId: 0,
    logo: "",
    logo2: "",
    template: {
      colors: {
        navbar: "#ffffff",
        primary: "sirit_blue",
        secondary: "blue_gray",
      },
    },
  },
  {
    url: "trecupera-dev",
    tenantId: 1,
    logo: "Moments_white.png",
    logo2: "Logo_2.png",
    template: {
      colors: {
        navbar: "#ffffff",
        primary: "sirit_blue",
        secondary: "blue_gray",
      },
    },
  },
  {
    url: "trecupera-pre",
    tenantId: 1,
    logo: "Moments_white.png",
    logo2: "Logo_2.png",
    template: {
      colors: {
        navbar: "#ffffff",
        primary: "sirit_blue",
        secondary: "blue_gray",
      },
    },
  },
  {
    url: "moments",
    tenantId: 1,
    logo: "Moments_white.png",
    logo2: "Logo_2.png",
    template: {
      colors: {
        navbar: "#ffffff",
        primary: "sirit_blue",
        secondary: "blue_gray",
      },
    },
  },
  {
    url: "www",
    tenantId: 2,
    logo: "",
    logo2: "Logo_2.png",
    template: {
      colors: {
        navbar: "#ffffff",
        primary: "sirit_blue",
        secondary: "blue_gray",
      },
    },
  },
  {
    url: "wivai",
    tenantId: 1,
    logo: "Moments_white.png",
    logo2: "Logo_2.png",
    template: {
      colors: {
        navbar: "#ffffff",
        primary: "sirit_blue",
        secondary: "blue_gray",
      },
    },
  },
];

export const setConfigTenant = () => {
  const currentDomain = localStorage.getItem("subDomain")
    ? localStorage.getItem("subDomain")
    : "www";
  const tenant = configEnv.filter((tenant) => tenant.url === currentDomain);
  if (tenant[0] === undefined){
    return configEnv[4]
  }


  return tenant[0];
};
